module.exports = __webpack_public_path__ + "static/media/kecambah.44229d90.jpeg";